// @ts-nocheck
/**
 * Common Auth Configuration Constants
 * Centralized configuration for common authentication system
 */

// Authentication URLs and endpoints
export const COMMON_AUTH_CONFIG = {
  // Logout redirect URL - should be configurable via environment
  LOGOUT_REDIRECT_URL: window?.CONFIG?.COMMON_AUTH_LOGOUT_URL,

  // Timeout configurations
  LOGOUT_REDIRECT_DELAY: 1000, // 1 second delay before redirect

  // Required URL parameters for common auth
  REQUIRED_URL_PARAMS: [
    'access_token',
    'refresh_token',
    'realm_id',
    'session_id',
  ],
};

// Validation functions
export const isCommonAuthEnabled = () => {
  // This is added because if common auth login is enabled in config, we want to use common auth regardless of the URL parameter or localStorage value. This is to ensure that if common auth is enabled, users don't accidentally end up in a login loop by setting the URL parameter or localStorage value incorrectly.
  if (window?.CONFIG?.COMMON_AUTH_LOGIN === true) {
    return true;
  }
  // Check if normal auth is explicitly requested via URL parameter
  const urlParams = new URLSearchParams(window.location.search);
  const loginWithNormalAuth = urlParams.get('loginWithNormalAuth');

  // If loginWithNormalAuth parameter is present, process it and clean the URL
  if (loginWithNormalAuth !== null) {
    // Process the parameter
    if (loginWithNormalAuth === 'true') {
      localStorage.setItem('forceNormalAuth', 'true');
    } else if (loginWithNormalAuth === 'false') {
      localStorage.removeItem('forceNormalAuth');
    }

    // Remove the parameter from URL to keep it clean
    urlParams.delete('loginWithNormalAuth');
    const newUrl = `${window.location.pathname}${
      urlParams.toString() ? `?${urlParams.toString()}` : ''
    }${window.location.hash}`;

    // Update the URL without triggering a page reload
    window.history.replaceState({}, '', newUrl);

    // Return the result based on the processed parameter
    if (loginWithNormalAuth === 'true') {
      return false;
    }
  }

  // Check if normal auth was previously forced via localStorage
  const forceNormalAuth = localStorage.getItem('forceNormalAuth');
  if (forceNormalAuth === 'true') {
    return false;
  }

  return window?.CONFIG?.COMMON_AUTH_LOGIN === true;
};

/**
 * Validates that all required authentication parameters are present and not empty
 * @param {Object} authParams - Object containing authentication parameters
 * @returns {boolean} - True if all required parameters are valid, false otherwise
 */
export const validateCommonAuthParams = (authParams) => {
  return COMMON_AUTH_CONFIG.REQUIRED_URL_PARAMS.every(
    (param) =>
      authParams?.[param] !== null &&
      authParams?.[param] !== '' &&
      authParams?.[param] !== undefined
  );
};
